'use strict';
var __importDefault =
  (this && this.__importDefault) ||
  function (mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, '__esModule', { value: true });
exports.useInternalForm =
  exports.useForm =
  exports.SubmitButton =
  exports.formatFileSize =
  exports.FileInput =
  exports.DateInput =
  exports.convertUTCToLocalDate =
  exports.convertLocalToUTCDate =
  exports.Input =
  exports.checkValidity =
  exports.ErrorMsgs =
  exports.Banner =
    void 0;
const Form_1 = __importDefault(require('./components/Form'));
exports.default = Form_1.default;
var Banner_1 = require('./components/Banner');
Object.defineProperty(exports, 'Banner', {
  enumerable: true,
  get: function () {
    return __importDefault(Banner_1).default;
  },
});
var ErrorMsgs_1 = require('./components/ErrorMsgs');
Object.defineProperty(exports, 'ErrorMsgs', {
  enumerable: true,
  get: function () {
    return __importDefault(ErrorMsgs_1).default;
  },
});
var _helpers_1 = require('./components/Inputs/_helpers');
Object.defineProperty(exports, 'checkValidity', {
  enumerable: true,
  get: function () {
    return _helpers_1.checkValidity;
  },
});
var BaseInput_1 = require('./components/Inputs/BaseInput');
Object.defineProperty(exports, 'Input', {
  enumerable: true,
  get: function () {
    return __importDefault(BaseInput_1).default;
  },
});
var DateInput_1 = require('./components/Inputs/DateInput');
Object.defineProperty(exports, 'convertLocalToUTCDate', {
  enumerable: true,
  get: function () {
    return DateInput_1.convertLocalToUTCDate;
  },
});
Object.defineProperty(exports, 'convertUTCToLocalDate', {
  enumerable: true,
  get: function () {
    return DateInput_1.convertUTCToLocalDate;
  },
});
Object.defineProperty(exports, 'DateInput', {
  enumerable: true,
  get: function () {
    return __importDefault(DateInput_1).default;
  },
});
var FileInput_1 = require('./components/Inputs/FileInput');
Object.defineProperty(exports, 'FileInput', {
  enumerable: true,
  get: function () {
    return __importDefault(FileInput_1).default;
  },
});
Object.defineProperty(exports, 'formatFileSize', {
  enumerable: true,
  get: function () {
    return FileInput_1.formatFileSize;
  },
});
var SubmitButton_1 = require('./components/SubmitButton');
Object.defineProperty(exports, 'SubmitButton', {
  enumerable: true,
  get: function () {
    return __importDefault(SubmitButton_1).default;
  },
});
var form_1 = require('./contexts/form');
Object.defineProperty(exports, 'useForm', {
  enumerable: true,
  get: function () {
    return form_1.useForm;
  },
});
// Exported here, and NOT imported from './contexts/form' directly: a bare
// import of that CJS file from ESM gets its own copy of the module under
// vite, so the hook reads a second, empty FormContext and every consumer
// sees `undefined` where the form state should be. Reached through this
// barrel — the same path `ErrorMsgs` and `useForm` come through — it shares
// the instance the surrounding <Form> provides.
Object.defineProperty(exports, 'useInternalForm', {
  enumerable: true,
  get: function () {
    return form_1.useInternalForm;
  },
});
//# sourceMappingURL=index.js.map
